// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3FPeK","buttons":"SendReceipts_buttons__13kqI","email":"SendReceipts_email__3JEzn","bookApptTitle":"SendReceipts_bookApptTitle__2S4ad"};